import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../utils/baseQueryWithAuth';

// Define a service using a base URL and expected endpoints
export const energyConsumptionApiV2 = createApi({
  reducerPath: 'energyConsumptionApiV2',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getConsumersEnergyConsumption: builder.query({
      query: (params) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/cis/get_master_data/consumer-data/`,
        params: params
      }),
      keepUnusedDataFor: 300
    }),
    getConsumerCounts: builder.query({
      query: (params) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/cis/get_master_data/consumer-counts/`,
        params: params
      }),
      keepUnusedDataFor: 300
    }),
    getPrepaidLedger: builder.query({
      query: (params) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/prepaid-engine/mdms_api/prepaid_ledger/${params.accountId}/${params.meterNumber}`
      }),
      keepUnusedDataFor: 300
    }),
    getWalletDetails: builder.query({
      query: (params) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/prepaid-engine/mdms_api/wallet_details/${params.accountId}/${params.meterNumber}`
      }),
      keepUnusedDataFor: 300
    }),
    getRechargeHistory: builder.query({
      query: (params) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/prepaid-engine/mdms_api/recharge_history_new/${params.accountId}/${params.meterNumber}`
      })
    }),
    getDailyLoad: builder.mutation({
      query: (data) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/db-service/dailyloads`,
        body: data,
        method: 'POST'
      })
    }),
    getBlockLoad: builder.mutation({
      query: (data) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/db-service/blockloads/`,
        body: data,
        method: 'POST'
      })
    }),
    getBillingHistory: builder.mutation({
      query: (data) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/db-service/monthlybilling/`,
        body: data,
        method: 'POST'
      })
    }),
    getMeterRecentAlerts: builder.mutation({
      query: (data) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/db-service/pushevents/recents`,
        method: 'POST',
        body: data
      }),
      keepUnusedDataFor: 300
    }),
    getAllPushEvents: builder.mutation({
      query: (data) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/db-service/pushevents`,
        method: 'POST',
        body: data
      }),
      keepUnusedDataFor: 300
    }),
    getAllPullEvents: builder.mutation({
      query: (data) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/db-service/pullevents`,
        method: 'POST',
        body: data
      }),
      keepUnusedDataFor: 300
    }),
    getRcDcMeterCommand: builder.query({
      query: (params) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/mdms-cmd/cmd_meter_rcdc/`,
        params: params
      }),
      keepUnusedDataFor: 300
    }),
    getOtherMeterCommand: builder.query({
      query: (params) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/mdms-cmd/cmd_meter_other/`,
        params: params
      })
    }),
    getMdmsSearchResult: builder.query({
      query: (params) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/cis/save_master_data/search`,
        params
      }),
      keepUnusedDataFor: 300
    }),
    getMdmsUserInfo: builder.query({
      query: (params) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/cis/user-info`,
        params
      }),
      keepUnusedDataFor: 300
    }),
    getDTRMetaInfo: builder.query({
      query: (params) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/asset-management/dt_meter_info/`,
        params
      }),
      keepUnusedDataFor: 300
    }),
    getFeederMetaInfo: builder.query({
      query: (params) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/asset-management/feeder_meter_info/`,
        params
      }),
      keepUnusedDataFor: 300
    }),
    getPeriodicPush: builder.mutation({
      query: (data) => ({
        url: `${process.env.REACT_APP_MDMS_URL}/db-service/periodicpush`,
        body: data,
        method: 'POST'
      })
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetConsumersEnergyConsumptionQuery,
  useGetConsumerCountsQuery,
  useGetPrepaidLedgerQuery,
  useGetWalletDetailsQuery,
  useLazyGetRechargeHistoryQuery,
  useGetDailyLoadMutation,
  useGetBillingHistoryMutation,
  useGetMeterRecentAlertsMutation,
  useGetAllPushEventsMutation,
  useGetAllPullEventsMutation,
  useGetOtherMeterCommandQuery,
  useGetRcDcMeterCommandQuery,
  useGetBlockLoadMutation,
  useLazyGetMdmsSearchResultQuery,
  useLazyGetMdmsUserInfoQuery,
  useGetDTRMetaInfoQuery,
  useGetFeederMetaInfoQuery,
  useGetPeriodicPushMutation
} = energyConsumptionApiV2;
